import { create } from "zustand";
import { MasterListItem } from "pages/master/finance/types";
import { ObjectType } from "pages/admin/objectsAndClients/objects/types";

export type MasterInvoiceStoreState = {
  list: { isLoaded: boolean; data: MasterListItem[] };
  setList: (list: { isLoaded: boolean; data: MasterListItem[] }) => void;
  objectsList: { isLoaded: boolean; data: ObjectType[] };
  setObjectsList: (list: { isLoaded: boolean; data: ObjectType[] }) => void;
  isPostInProcess: boolean;
  setIsPostInProcess: (isPostInProcess: boolean) => void;
  isSubmittable: boolean;
  setIsSubmittable: (isSubmittable: boolean) => void;
  isError: boolean;
  setIsError: (isError: boolean) => void;
  isFileUploading: boolean;
  setIsFileUploading: (isFileUploading: boolean) => void;
  isChangeStatusInProcess: { [objectId: number]: boolean };
  setIsChangeStatusInProcess: (
    updater:
      | { [objectId: number]: boolean }
      | ((prevState: {
          [objectId: number]: boolean;
        }) => { [objectId: number]: boolean })
  ) => void;
};

const useMasterInvoiceStore = create<MasterInvoiceStoreState>((set) => ({
  list: {
    isLoaded: false,
    data: [],
  },
  setList: (list) => set({ list }),
  objectsList: {
    isLoaded: false,
    data: [],
  },
  setObjectsList: (objectsList) => set({ objectsList }),
  isPostInProcess: false,
  setIsPostInProcess: (isPostInProcess) => set({ isPostInProcess }),
  isSubmittable: false,
  setIsSubmittable: (isSubmittable) => set({ isSubmittable }),
  isError: false,
  setIsError: (isError) => set({ isError }),
  isFileUploading: false,
  setIsFileUploading: (isFileUploading) => set({ isFileUploading }),
  isChangeStatusInProcess: {},
  setIsChangeStatusInProcess: (updater) => {
    if (typeof updater === "function") {
      set((state) => ({
        isChangeStatusInProcess: updater(state.isChangeStatusInProcess),
      }));
    } else {
      set({ isChangeStatusInProcess: updater });
    }
  },
}));

export default useMasterInvoiceStore;
